import { format } from "date-fns";
import Tooltip from "../Tooltip/Tooltip";

function FormattedDate({ date: dateString }: { date: string }) {
  if (!dateString) {
    return "-";
  }

  const date = new Date(dateString);

  return (
    <Tooltip content={format(date, "PPpp")}>
      {format(date, "MMM d, yyyy")}
    </Tooltip>
  );
}

export default FormattedDate;
